import { ORG_SHORT_NAME } from "../util/appInfo";

export const ROUTES = {
  MAIN: "main",
  BENEFICIARY: "beneficiary",
  ENROLMENT: "enrolment",
  SCHEDULE: "schedule",
  SIGN_IN: "auth/signin",
  AUTH_SUCCESS: "auth/success",
  FORBIDDEN: "forbidden",
  MAINTENANCE: "maintenance",
  MANAGER_USERS: "manager-users",
  MY_PROFILE: "my-profile",
};

export const APP_ROOT = "/app/";

export const absolutePath = (path) => {
  return `${APP_ROOT}${path}`;
};

const FAQ_URL_BY_ORG = {
  UNJSPF:
    "https://www.unjspf.org/for-clients/digital-certificate-of-entitlement/",
  IDB: "https://www.iadb.org/",
};

export const FAQ_URL = FAQ_URL_BY_ORG[ORG_SHORT_NAME];
